import { render, staticRenderFns } from "./WidgetFormItem.vue?vue&type=template&id=94531764&scoped=true"
import script from "./WidgetFormItem.vue?vue&type=script&lang=js"
export * from "./WidgetFormItem.vue?vue&type=script&lang=js"
import style0 from "./WidgetFormItem.vue?vue&type=style&index=0&id=94531764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94531764",
  null
  
)

export default component.exports